export default __webpack_public_path__ + "static/media/DC_logo_for web_indigo.5814763b.png";